<template>
    <div id="page" class="container-fluid">
        <div class="row header mx-4 mt-3">
            <div class="col header-row">
                <h1>Appointments</h1>
            </div>
                <div class="row filter-row mb-1">
                  <div class="patient-search-section mr-2">
                    <b-input-group class="patient-search-border text-right">
                        <b-form-input ref="searchInput"
                                      placeholder="Search (Patient Name or ID)"
                                      class="patient-search"
                                      v-model="searchTerm"></b-form-input>
                        <b-input-group-append>
                            <button class="btn btn-default patient-search-submit" type="button">
                                <font-awesome-icon icon="search"/>
                            </button>
                    </b-input-group-append>
                    </b-input-group>
                  </div>
                  <b-form-group class="mr-2" label-class="ml-2" label="Start Date">
                  <b-form-datepicker
                      class="orange-border form-control datepicker"
                      :hide-header="true"
                      :value-as-date="true"
                      :date-format-options="{month: 'short', day: 'numeric', year: 'numeric'}"
                      v-model="fromDate"/>
                  </b-form-group>
                  <b-form-group class="mr-2" label-class="ml-2" label="Start Time">
                  <b-form-timepicker
                      class="orange-border form-control"
                      :hide-header="true"
                      v-model="fromTime"/>
                  </b-form-group>
                  <b-form-group class="mr-2" label-class="ml-2" label="End Date">
                  <b-form-datepicker
                      class="orange-border form-control datepicker"
                      :hide-header="true" :value-as-date="true"
                      v-model="toDate"
                      :date-format-options="{month: 'short', day: 'numeric', year: 'numeric'}"/>
                  </b-form-group>
                  <b-form-group class="mr-2" label-class="ml-2" label="End Time">
                  <b-form-timepicker
                      class="orange-border form-control"
                      :hide-header="true"
                      v-model="toTime"
                      offset="-100"/>
                  </b-form-group>
                </div>
            </div>
      <div class="row ml-4">
      <div class="col">
          <button v-if="organization.customNotificationsEnabled" @click.stop="showingMassNotificationsModal = !showingMassNotificationsModal" class="btn btn-outline-orange"><font-awesome-icon class="orange mr-2" :icon="[ 'fas', 'comment-sms' ]"/>Send Message to All</button>
      </div>
              <div class="row text-right mx-4 pb-4">
                <button name="providers" class="btn btn-outline-orange providers-filter mr-2"
                        @click.prevent="showingLocationList = !showingLocationList">
                  <font-awesome-icon class="orange mr-2" :icon="[ 'fas', 'location-dot' ]"/>Locations <b-badge v-show="selectedLocationIds.length > 0" variant="orange">{{ selectedLocationIds.length }}</b-badge>
                </button>

                <button name="providers" class="btn btn-outline-orange providers-filter mr-2"
                        @click.prevent="showingProviderList = !showingProviderList">
                  <font-awesome-icon class="orange mr-2" :icon="[ 'fas', 'user-doctor' ]"/>Providers <b-badge v-show="selectedProviderIds.length > 0" variant="orange">{{ selectedProviderIds.length }}</b-badge>
                </button>
                <b-btn @click.stop="statusPopoverShowing = !statusPopoverShowing"
                       id="visit-statuses" variant="outline-orange mr-2">
                  <font-awesome-icon class="orange mr-2" :icon="[ 'far', 'bars-progress' ]"/>Statuses<b-badge v-show="selectedVisitStatuses.length > 0" variant="orange" class="ml-2">{{ selectedVisitStatuses.length }}</b-badge>
                </b-btn>
                <b-popover :show.sync="statusPopoverShowing"
                           target="visit-statuses" placement="bottomleft" triggers="">
                  <b-form-group v-click-outside="hideStatusPopover" class="status-popover" label="Visit Status">
                    <b-form-checkbox-group stacked v-model="selectedVisitStatuses" name="visitStatuses" :options="visitStatuses">
                    </b-form-checkbox-group>
                  </b-form-group>
                </b-popover>
                <button name="visit-types" class="btn btn-outline-orange visit-types-filter mr-2"
                        @click.prevent="showingVisitTypeList = !showingVisitTypeList">
                  <font-awesome-icon class="orange mr-2" :icon="[ 'fas', 'user-doctor' ]"/>Intake Flows <b-badge v-show="selectedVisitTypeIds.length > 0" variant="orange">{{ selectedVisitTypeIds.length }}</b-badge>
                </button>
              </div>
        </div>

        <div class="container-fluid">
            <div class="row visits-header">
                <div class="col-2"><img style="width:20px;" src="../assets/q-logo.svg"> &nbsp;
                  <a href="#" @click.prevent="sort('StartDate')">Appointment {{ sortIndicator ('StartDate') }}</a>
                </div>
                <div class="col-2" id="visit-name-header"> <a href="#" @click.prevent="sort('Patient')">Name {{ sortIndicator ('Patient') }}</a></div>
                <div class="col-1"><a href="#" @click.prevent="sort('DateOfBirth')">DOB {{ sortIndicator ('DateOfBirth') }}</a></div>
                <div class="col-1"><a href="#" @click.prevent="sort('VisitType')">Intake Flow{{ sortIndicator ('VisitType') }}</a></div>
                <template v-if="showPayments">
                    <div class="col-1"><a href="#" @click.prevent="sort('Location')">Location {{ sortIndicator ('Location') }}</a></div>
                    <div class="col-1"><a href="#" @click.prevent="sort('AmountDue')">Charges {{ sortIndicator ('AmountDue') }}</a></div>
                    <div class="col-1"><a href="#" @click.prevent="sort('VisitState')">Status {{ sortIndicator ('VisitState') }}</a></div>
                </template>
                <template v-else>
                    <div class="col-2"><a href="#" @click.prevent="sort('Location')">Location {{ sortIndicator ('Location') }}</a></div>
                    <div class="col-1"><a href="#" @click.prevent="sort('VisitState')">Status {{ sortIndicator ('VisitState') }}</a></div>
                </template>
                <div class="col-3"></div>
            </div>
          <div class="row justify-content-center m-2">
            <b-alert class="col-6" v-if="generalErrorMessage" :show="true" fade variant="danger">
              {{ generalErrorMessage }}
            </b-alert>
          </div>
            <div v-for="visit in visits" class="row visit-row align-items-center" :key="visit.visitId">
              <div class="column col-2">
                {{ formatAppointmentDate(visit.appointmentStartDate) }}</div>
              <div class="column col-2">
                            <a @click.prevent="editPatient(visit.organizationPatientId)" href="#">{{ visit.lastName +', ' + visit.firstName }}</a>
              </div>
              <div class="column col-1">{{ formatBirthDate(visit.dob) }}</div>
              <div class="col-1">{{ visit.visitTypeName }}</div>
              <template v-if="showPayments">
                <div class="column col-1">{{ visit.location ? visit.location.name : 'Location Not Set' }}</div>
                <div class="column col-1">
                  <a v-if="visit.totalAmount > 0 && visit.successfulPayments.length === 0 || isOrgAdmin" @click.prevent="addCharge(visit)" href="#">{{ formatNumber(visit.totalAmount) }}&nbsp;&nbsp;<font-awesome-icon size="sm" :icon="['far', 'edit']"/></a>
                  <div v-if="visit.totalAmount > 0 && visit.successfulPayments.length > 0" href="#">{{ formatNumber(visit.totalAmount) }}&nbsp;&nbsp;</div> <div v-if="visit.totalPaid > 0">Paid: {{formatNumber(visit.totalPaid)}}</div>
                  <a v-if="visit.totalAmount <= 0" href="#" @click.prevent="addCharge(visit)">&nbsp;<font-awesome-icon size="sm" icon="plus"/> Add Charge</a>
                </div>
                <div class="column col-1">{{ visit.visitState }}</div>
              </template>
              <template v-else>
                <div class="column col-2">{{ visit.location ? visit.location.name : 'Location Not Set' }}</div>
                <div class="column col-1">{{ visit.visitState }}</div>
              </template>
                <div class="column col-3 text-right">
                  <button v-if="organization.customNotificationsEnabled" @click.stop="showNotifications(visit)" class="btn btn-outline-orange m-1 wide-button"><font-awesome-icon class="orange mr-2" :icon="[ 'far', 'sms' ]"/>Send Message</button>
                  <button :disabled="visit.visitState === 'NeedsReview' || visit.visitState === 'Scheduled' || visit.visitState === 'InProgress'" @click.stop="showFacesheet(visit)" type="button" class="btn btn-outline-orange m-1 wide-button"><font-awesome-icon class="orange mr-2" icon="address-card"/>Summary</button>
                </div>
            </div>
        </div>

        <div class="alert alert-secondary" role="alert" v-show="!visits.length && !generalErrorMessage">
            &nbsp;&nbsp;No visits were found for the specified locations, providers and date range
        </div>

      <pdf-view-modal :is-face-sheet="true" :title="pdfTitle" :url="pdfUrl" :visible="showingPdfModal"
                      @update:visible="visible => showingPdfModal = visible"></pdf-view-modal>

        <location-select @saveLocationIds="locationSelectionChanged"
                         :selected-location-ids="selectedLocationIds" :visible="showingLocationList"
                         @update:visible="visible => showingLocationList = visible"></location-select>

        <provider-select @saveProviderIds="providerSelectionChanged"
                         :selected-provider-ids="selectedProviderIds" :visible="showingProviderList"
                         @update:visible="visible => showingProviderList = visible"></provider-select>

        <visit-type-select @saveVisitTypeIds="visitTypeSelectionChanged"
                           :is-visit-category="false"
                           :selected-visit-type-ids="selectedVisitTypeIds" :visible="showingVisitTypeList"
                           @update:visible="visible => showingVisitTypeList = visible"></visit-type-select>

        <loading-modal :visible="showingLoadingModal" :return-focus="$refs.searchInput"
                       @update:visible="visible => showingLoadingModal = visible"></loading-modal>

        <visit-charges-modal :title="visitChargeModalTitle" :visit-id="visitChargeVisit.visitId" @chargeAdded="chargeAdded" :visible="showingVisitCharge" @closeModal="closeVisitChargeModal"></visit-charges-modal>
        <send-custom-notification :visible="showingNotificationsModal" :visit-id="notificationVisitId" @notificationSent="notificationSent" @update:visible="visible => showingNotificationsModal = visible"></send-custom-notification>
        <send-mass-custom-notification ref="massNotificationModal" :visible="showingMassNotificationsModal" :from-date="fromDateTime" :to-date="toDateTime" :provider-ids="selectedProviderIds" :location-ids="selectedLocationIds" :visit-statuses="selectedVisitStatuses" :intake-flows="selectedVisitTypeIds"  @update:visible="visible => showingMassNotificationsModal = visible" @confirmMassNotifications="confirmMassNotifications"></send-mass-custom-notification>
      <confirm-modal @confirmed="massNotificationsConfirmed" title="Notification Confirmation"
                     confirmButton="Confirm"
                     :visible="showMassNotificationConfirmation"
                     @update:visible="visible => showMassNotificationConfirmation = false">
        <div class="mb-4 align-items-center text-center"><font-awesome-icon size="sm" class="text-warning mr-2 align-baseline" icon="exclamation-triangle"/>Please verify the information below and confirm the notifications.</div>
        <div>
          <div class="row align-items-center mb-3">
            <div class="col-1 column"/>
            <div class="col-4 text-right column">Message:</div>
            <div class="col-6 text-left column">{{ pendingMassNotifications.message }}</div>
          </div>

          <div class="row align-items-center mb-3">
              <div class="col-1 column"/>
              <div class="col-4 text-right column">Date Range:</div>
              <div class="col-6 text-left column">{{ pendingMassNotifications.dateRange }}</div>
            </div>
            <div class="row align-items-center mb-3">
              <div class="col-1 column"/>
              <div class="col-4 text-right column">Provider:</div>
              <div class="col-4 text-left column"><span v-html="pendingMassNotifications.providerNames"></span></div>
            </div>
            <div class="row align-items-center mb-3">
              <div class="col-1 column"/>
              <div class="col-4 text-right column">Location:</div>
              <div class="col-4 text-left column"><span v-html="pendingMassNotifications.locationNames"></span></div>
            </div>
            <div class="row align-items-center mb-3">
              <div class="col-1 column"/>
              <div class="col-4 text-right column">Total Messages to Send:</div>
              <div class="col-4 text-left column">{{ pendingMassNotifications.patientCount }}</div>
            </div>
          <div class="row align-items-center mb-3">
            <div class="col-1 column"/>
            <div class="col-4 text-right column">Visit Statuses:</div>
            <div class="col-4 text-left column"><div v-for="status in pendingMassNotifications.visitStatuses" :key="status">{{ statusName(status) }}</div></div>
          </div>
          <div class="row align-items-center mb-3">
            <div class="col-1 column"/>
            <div class="col-4 text-right column">Intake Flows:</div>
            <div class="col-4 text-left column"><span v-html=" pendingMassNotifications.intakeNames"></span></div>
          </div>

          </div>
      </confirm-modal>

      <paginator :totalPages="totalPages" :currentPage="currentPage" @update:currentPage="newPage => currentPage = newPage"></paginator>
    </div>
</template>

<script>
  import LoadingModal from '../components/LoadingModal'
  import Paginator from '../components/Paginator'
  import ProviderSelect from '../components/ProviderSelect'
  import LocationSelect from '../components/LocationSelect'
  import moment from 'moment-timezone'
  import api from '../services/api'
  import _ from 'lodash'
  import VisitChargesModal from '../components/VisitChargesModal'
  import ConfirmModal from '../components/ConfirmModal'
  import SendCustomNotification from '../components/SendCustomNotification'
  import SendMassCustomNotification from '../components/SendMassCustomNotification'
  import PdfViewModal from '@/components/PdfViewModal'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'
  import ErrorsMixin from '../mixins/ErrorsMixin'
  import VisitTypeSelect from '@/components/VisitTypeSelect.vue'

  export default {
    name: 'Visits',

    components: { VisitTypeSelect, ConfirmModal, PdfViewModal, LoadingModal, Paginator, ProviderSelect, LocationSelect, VisitChargesModal, SendCustomNotification, SendMassCustomNotification },

    mixins: [AnalyticsMixin, ErrorsMixin],

    data () {
      return {
        activeVisit: null,
        currentPage: 1,
        editingPatientId: 0,
        fromDate: moment().startOf('day').utc().toJSON(),
        fromTime: '00:00',
        visitTypeOptions: [],
        intakePopoverShowing: false,
        nextGenTitle: 'Update NextGen',
        notificationVisitId: 0,
        pageSize: 20,
        pdfTitle: '',
        pdfUrl: '',
        pendingMassNotifications: {},
        restoringSettings: false,
        searchDebounceFn: null,
        searchTerm: '',
        selectedVisitTypes: [],
        selectedLocationIds: [],
        selectedProviderIds: [],
        selectedVisitTypeIds: [],
        selectedVisitStatuses: [1, 2, 3, 4, 5, 6],
        showMassNotificationConfirmation: false,
        showNextGenReminder: false,
        showingLoadingModal: false,
        showingLocationList: false,
        showingMassNotificationsModal: false,
        showingNotificationsModal: false,
        showingPatientDetails: false,
        showingPdfModal: false,
        showingProviderList: false,
        showingVisitCharge: false,
        showingVisitDetails: {},
        showingVisitTypeList: false,
        sortBy: null,
        sortOrder: null,
        statusPopoverShowing: false,
        toDate: moment().startOf('day').add(1, 'day').utc().toJSON(),
        toTime: '23:59',
        totalPages: 0,
        visitChargeModalTitle: 'Visit Charges',
        visitChargeVisit: {
          visitId: 0
        },
        visitStatuses: [
          { text: 'Scheduled', value: 1 },
          { text: 'In Progress', value: 2 },
          { text: 'Pre Checked', value: 3 },
          { text: 'Needs Review', value: 4 },
          { text: 'Checked In', value: 5 },
          { text: 'Done', value: 6 }
        ],
        visits: []
      }
    },

    watch: {
      currentPage (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.loadVisits()
        }
      },
      fromDate (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },
      fromTime (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },
      searchTerm (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },
      selectedVisitStatuses (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          if (newValue.length === 0) {
            this.selectedVerificationStatuses = [1, 2, 3, 4, 5, 6]
          }
          this.searchDebounceFn()
        }
      },
      toDate (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },
      toTime (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      }
    },

    computed: {
      showPayments () {
        return this.$store.organization.paymentEnabled
      },
      isOrgAdmin () {
        return this.$store.isOrgAdmin
      },
      organization () {
        return this.$store.organization
      },
      fromDateTime () {
        if (this.fromTime) {
          return moment(moment(this.fromDate).format('YYYY/MM/DD') + ' ' + this.fromTime, 'YYYY/MM/DD HH:mm').toDate()
        } else {
          return moment(this.fromDate).toDate()
        }
      },
      toDateTime () {
        if (this.toTime) {
          return moment(moment(this.toDate).format('YYYY/MM/DD') + ' ' + this.toTime, 'YYYY/MM/DD HH:mm').toDate()
        } else {
          return moment(this.toDate).toDate()
        }
      },
      providers () {
        return this.$store.organization.providers
      },
      allProviderIds () {
        return this.providers.map(aProvider => {
          return aProvider.providerId
        })
      },
      locations () {
        return this.$store.organization.locations
      },
      allLocationIds () {
        return this.locations.map(aLocation => {
          return aLocation.locationId
        })
      },
      visitTypes () {
        return this.$store.organization.visitTypes
      },

      allVisitTypeIds () {
        return this.visitTypes.map(aVisitType => {
          return aVisitType.organizationVisitTypeId
        })
      }
    },

    methods: {
      formatNumber (number) {
        if (number) {
          return '$ ' + number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }
        return ''
      },

      locationSelectionChanged (selectedIds) {
        this.selectedLocationIds = selectedIds
        this.showingLocationList = false
        this.loadVisits()
      },

      providerSelectionChanged (selectedIds) {
        this.selectedProviderIds = selectedIds
        this.showingProviderList = false
        this.loadVisits()
      },

      visitTypeSelectionChanged (selectedIds) {
        this.selectedVisitTypeIds = selectedIds
        this.showingVisitTypeList = false
        this.loadVisits()
      },

      addCharge (visit) {
        this.visitChargeModalTitle = 'Visit Charges for ' + visit.firstName + ' ' + visit.lastName
        this.visitChargeVisit = visit
        this.showingVisitCharge = true
      },

      chargeAdded (charge) {
        this.showingVisitCharge = false
        this.loadVisits()
      },

      closeVisitChargeModal (updated) {
        this.showingVisitCharge = false
        if (updated) {
          this.loadVisits()
        }
      },

      hideStatusPopover () {
        if (this.statusPopoverShowing) {
          this.$root.$emit('bv::hide::popover')
        }
      },

      hideIntakePopover () {
        if (this.intakePopoverShowing) {
          this.$root.$emit('bv::hide::popover')
        }
      },

      showNotifications (visit) {
        this.notificationVisitId = visit.visitId
        this.showingNotificationsModal = true
      },

      notificationSent (notification) {
        this.notificationVisitId = 0
        this.showingNotificationsModal = false
      },
      statusName (status) {
        switch (status) {
        case 1: return 'Scheduled'
        case 2: return 'In Progress'
        case 3: return 'Pre Checked'
        case 4: return 'Needs Review'
        case 5: return 'Checked In'
        case 6: return 'Done'
        }
      },
      showFacesheet (visit) {
        this.showingLoadingModal = true
        this.pdfTitle = 'Summary for ' + visit.lastName + ', ' + visit.firstName
        api.get('/Dashboard/Download/' + visit.visitId + '/Facesheet/', {
          responseType: 'blob',
          headers: { 'Content-Type': 'application/pdf' }
        }).then(response => {
          this.trackEvent('Visit', 'Facesheet', 'ResponseTime', response.config.requestDuration)
          this.trackEvent('Visit', 'Facesheet', 'Show', visit.visitId)
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(response.data, 'facesheet.pdf')
          } else {
            this.pdfUrl = URL.createObjectURL(response.data)
            this.showingPdfModal = true
          }
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Visit', 'FacesheetError', error.message)
            this.$log.error('Error attempting to load facesheet: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          // always executed
          this.showingLoadingModal = false
        })
      },
      loadVisits (silent = false) {
        if (!silent) {
          this.showingLoadingModal = true
        }
        if (this.isLoading) {
          return
        }
        let paramStates = []
        if (JSON.stringify(this.selectedVisitStatuses.sort()) !== JSON.stringify([1, 2, 3, 4, 5, 6])) {
          paramStates = this.selectedVisitStatuses
        }

        let paramTypes = []
        if (JSON.stringify(this.selectedVisitTypeIds.sort()) !== JSON.stringify(this.allVisitTypeIds.sort())) {
          paramTypes = this.selectedVisitTypeIds
        }

        let paramProviders = []
        if (JSON.stringify(this.selectedProviderIds.sort()) !== JSON.stringify(this.allProviderIds.sort())) {
          paramProviders = this.selectedProviderIds
        }

        let paramLocations = []
        if (JSON.stringify(this.selectedLocationIds.sort()) !== JSON.stringify(this.allLocationIds.sort())) {
          paramLocations = this.selectedLocationIds
        }

        const parameters = {
          searchTerm: this.searchTerm,
          fromDate: this.fromDateTime,
          toDate: this.toDateTime,
          visitStates: paramStates,
          visitTypes: paramTypes,
          providerIds: paramProviders,
          locationIds: paramLocations,
          pageSize: this.pageSize,
          page: this.currentPage
        }
        if (this.sortBy) {
          parameters.sortBy = this.sortBy
        }
        if (this.sortOrder) {
          parameters.sortOrder = this.sortOrder
        }
        this.isLoading = true
        api.post('/Dashboard/Visits', parameters, { timeout: 180000 }).then(response => {
          this.trackEvent('Visit', 'Load', 'ResponseTime', response.config.requestDuration)
          this.isLoading = false
          this.persistSettings()
          this.visits = response.data.visits
          this.currentPage = response.data.page
          this.totalPages = Math.ceil(response.data.totalVisits / this.pageSize)
          this.sortBy = response.data.sortBy
          this.sortOrder = response.data.sortOrder
          if (this.autoRefreshEnabled) {
            setTimeout(this.refreshVisits, this.refreshInterval * 1000)
          }
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Visit', 'LoadError', error.message)
            this.$log.error('Error attempting to load visits: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
          setTimeout(() => {
            this.showingLoadingModal = false
          }, 100)
        })
      },

      editPatient (patientId) {
        this.$router.push({ name: 'patient-detail', params: { id: patientId } })
      },

      formatBirthDate (dob) {
        return moment(dob).utc().format('MM/DD/YYYY')
      },

      formatAppointmentDate (date) {
        return moment(date).format('MMM Do h:mm a')
      },

      handleLogin () {
        this.loadVisits()
      },

      handleOrgChange (newOrg, event) {
        localStorage.removeItem('appointmentsSelectedProviderIds')
        localStorage.removeItem('appointmentsSelectedLocationIds')
        this.selectedProviderIds = []
        this.selectedLocationIds = []
        this.restoreSettings()
        this.loadVisits()
      },

      persistSettings () {
        const visitFilters = {
          fromTime: this.fromTime,
          toTime: this.toTime,
          fromDate: moment(this.fromDate).toISOString(),
          toDate: moment(this.toDate).toISOString(),
          providerIds: this.selectedProviderIds,
          locationIds: this.selectedLocationIds,
          visitTypeIds: this.selectedVisitTypeIds,
          visitStates: this.selectedVisitStatuses
        }
        localStorage.setItem('selectedVisitFilters', JSON.stringify(visitFilters))
      },

      restoreSettings () {
        this.restoringSettings = true
        const settingVisitFilters = localStorage.getItem('selectedVisitFilters')
        if (settingVisitFilters) {
          const visitFilters = JSON.parse(settingVisitFilters)
          if (visitFilters.fromTime && visitFilters.fromTime !== 'null') {
            this.fromTime = visitFilters.fromTime
          }
          if (visitFilters.fromDate && visitFilters.fromDate !== 'null') {
            this.fromDate = visitFilters.fromDate
          }
          if (visitFilters.fromTime && visitFilters.fromTime !== 'null') {
            this.fromTime = visitFilters.fromTime
          }
          if (visitFilters.toDate && visitFilters.toDate !== 'null') {
            this.toDate = visitFilters.toDate
          }
          if (visitFilters.toTime && visitFilters.toTime !== 'null') {
            this.toTime = visitFilters.toTime
          }
          if (visitFilters.locationIds) {
            this.selectedLocationIds = visitFilters.locationIds
          }
          if (visitFilters.visitTypeIds) {
            this.selectedVisitTypeIds = visitFilters.visitTypeIds
          }
          if (visitFilters.providerIds) {
            this.selectedProviderIds = visitFilters.providerIds
          }
          if (visitFilters.visitStates) {
            this.selectedVisitStatuses = visitFilters.visitStates
          }
        }
        this.$nextTick(() => {
          this.restoringSettings = false
        })
      },

      sort (newOrder) {
        if (newOrder === this.sortBy) {
          if (this.sortOrder === 'Descending') {
            this.sortBy = null
            this.sortOrder = null
            this.loadVisits()

            return
          } else {
            this.sortOrder = 'Descending'
          }
        } else {
          this.sortOrder = 'Ascending'
        }

        this.sortBy = newOrder
        this.loadVisits()
      },

      sortIndicator (sortType) {
        if (sortType === this.sortBy) {
          if (this.sortOrder === 'Descending') {
            return '▼'
          } else {
            return '▲'
          }
        }

        return ''
      },

      confirmMassNotifications (settings) {
        this.pendingMassNotifications = settings
        this.showMassNotificationConfirmation = true
      },

      massNotificationsConfirmed (value) {
        if (value) {
          this.$refs.massNotificationModal.notificationsConfirmed()
        }
        this.showMassNotificationConfirmation = false
      }

    },

    created () {
      this.$store.$on('organization:changed', this.handleOrgChange)
      this.$store.$on('user:authenticated', this.handleLogin)
      this.searchDebounceFn = _.debounce(() => {
        if (this.searchTerm === '') {
          this.totalPages = Math.ceil(this.visits.totalVisits / this.pageSize)
          this.currentPage = 1
        } else {
          this.currentPage = 1
          this.totalPages = 0
        }
        this.loadVisits()
      }, 500)
      this.restoreSettings()
      if (this.$store.isAuthenticated) {
        this.loadVisits()
      }
    }

  }
</script>

<style scoped>
    .header div h1 {
        color: rgb(255, 70, 0);
        font-weight: lighter;
        font-size: 28px;
        margin: 0;
    }

    .header > h5 {
        margin-top: 0.5rem; /* Match bottom margin from bootstrap h5 */
    }

    .visits-header div {
        padding: 0.75rem;
        vertical-align: bottom;
        border-top: 1px solid #dee2e6;
        border-bottom: 2px solid #dee2e6;
        font-weight: bold;
        border-collapse: collapse;
    }

    .visit-row .column {
        padding: 0.75rem;
        vertical-align: bottom;
        border-collapse: collapse;
    }

    .visit-row {
        border-bottom: 1px solid #dee2e6;
        background-color: #f9f9f9;
        /*cursor: pointer;*/
    }

    .blank-label {
      color: transparent;
    }
    .header-row {
      margin-top: 28px;
    }
    .patient-search {
      min-width: 220px;
      height: 36px;
    }

    .patient-search-section {
      margin-top: 28px;
    }
    .alert {
      margin-bottom: 0;
    }
</style>
